import { mergeData } from '@/core/item_assistance/mergeItemData'
import { showMessageAlert } from '@/core/shared'
import { UPDATE_ITEM_DATA } from 'actions/configurations'
import { recursiveCalculations } from 'utils/calculations'

export let attributesRecalculate = {
	methods: {
		attributesRecalculate: function () {
			let vm = this
			let unsavedData = JSON.parse(JSON.stringify(editableTradeItem.unsavedDataManager.getUnsavedData()))
			let data = mergeData(this.$store.getters.getItemData, unsavedData)
			const itemStructure = this.$store.getters.getItemStructure

			let recalculateArray = this.$store.getters.getRecalculateAttributesList
			recalculateArray.forEach(function (value) {
				if (itemStructure[value].type === 'NM') {
					if (!data[value]) {
						data[value] = {'val': null, 'mu': itemStructure[value].defaultValue.mu}
					}
					data[value].val = recursiveCalculations(itemStructure[value].expression, data, itemStructure, vm).evaluate()
				} else if (itemStructure[value].type === 'B') {
					data[value] = !!recursiveCalculations(itemStructure[value].expression, data, itemStructure, vm).evaluate()
				} else {
					data[value] = recursiveCalculations(itemStructure[value].expression, data, itemStructure, vm).evaluate()
				}
			})

			this.$store.dispatch(UPDATE_ITEM_DATA, data).then(() => {})

			this.tabContentKey += 1

			this.$nextTick(function () {
				recalculateArray.forEach(function (attr) {
					editableTradeItem.unsavedDataManager.changesRegister(attr)
				})
			})

			showMessageAlert(this.$t('attributes.recalculated'), 'success')
		}
	}
}
